<template>
  <div>
    <!-- 售后 -->
    <baseBreadcrumb :page="$t('message.afterSale')" :menu="$t('message.money')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
          <!-- 待确认 -->
          <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
          </el-tab-pane>
          <!-- 待回复客户 -->
          <el-tab-pane :label="$t('message.customerToBeRepliedTo')" name="2">
          </el-tab-pane>
          <!-- 已完成 -->
          <el-tab-pane :label="$t('message.accomplish')" name="3">
          </el-tab-pane>
        </el-tabs>
        <div class="operation">
          <!-- 整个单子售后原因设置 -->
          <el-button type="success" @click="wholeListOfAftermarketReasonsSet" v-if="isAuth(330)">{{
            $t("message.wholeListOfAftermarketReasonsSet") }}</el-button>
          <!-- 整个单子费用调整名义设置 -->
          <el-button type="success" @click="chargeAdjustmentNominalSettingsThroughoutTheList" v-if="isAuth(331)">{{
            $t("message.chargeAdjustmentNominalSettingsThroughoutTheList")
          }}</el-button>
        </div>
        <!-- 注释 -->
        <div class="annotation">红色售后为超时未处理，请尽快处理</div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" type="datetime"
              default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" default-time="['23:59:59']"
              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px">
            </el-date-picker>
          </div>
          <!--   配送单号-->
          <div class="item">
            <el-input v-model="datas.porder_sn" :placeholder="$t('message.deliveryNoteNumber')"
              onfocus="this.select()" />
          </div>
          <!--  售后单号-->
          <div class="item">
            <el-input v-model="datas.after_sale_sn" :placeholder="$t('message.afterSalesOrderNumber')"
              onfocus="this.select()" />
          </div>
          <!--  赔款单号-->
          <div class="item">
            <el-input v-model="datas.reparation_sn" :placeholder="$t('message.claimNumber')" onfocus="this.select()" />
          </div>
          <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" onfocus="this.select()" />
          </div>
        </div>
        <div class="row">
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <!--  全体人员-->
          <div class="item">
            <el-select v-model="datas.reparation_amount_main" :placeholder="$t('message.specificPersonnel')" filterable
              clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--  售后类别-->
          <div class="item">
            <el-select v-model="datas.is_whole_porder" :placeholder="$t('message.afterSaleCategory')" filterable
              clearable>
              <el-option v-for="item in afterSaleCategory" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--  赔款状态-->
          <div class="item">
            <el-select v-model="datas.reparation_status_filter" :placeholder="$t('message.indemnityStatus')" filterable
              clearable>
              <el-option v-for="item in indemnityStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--  售后原因-->
          <div class="item">
            <el-select v-model="datas.reason_type" :placeholder="$t('message.afterSalesReasons')" filterable clearable>
              <el-option v-for="item in reasonList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--  是否有赔款单-->
          <div class="item">
            <el-select v-model="datas.hasReparation" :placeholder="$t('message.isThereACompensationClaim')" filterable
              clearable>
              <el-option label="有赔款单" value="HAS">
              </el-option>
              <el-option label="没有赔款单" value="NOT_HAS">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}</el-button>
          <!-- 重置 -->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" :height="tableautoheight"
          :row-class-name="tableRowClassName">
          <!-- NO -->
          <el-table-column align="center" label="NO" type="index" width="60">
          </el-table-column>
          <!-- 提出时间 -->
          <el-table-column align="center" :label="$t('message.forwardTime')" width="100" prop="created_at">
          </el-table-column>
          <!-- 售后号 -->
          <el-table-column align="center" :label="$t('message.afterSalesOrderNumber')" width="180">
            <template slot-scope="scope">
              <router-link :to="'/wholeOrderAfterSale?after_sale_sn=' + scope.row.after_sale_sn" class="a-link"
                target="_blank" v-if="scope.row.is_whole_porder == 1">
                {{ scope.row.after_sale_sn }}
              </router-link>
              <router-link :to="'/afterSaleOfGoods?after_sale_sn=' + scope.row.after_sale_sn" class="a-link"
                target="_blank" v-else>
                {{ scope.row.after_sale_sn }}
              </router-link>
            </template>
          </el-table-column>
          <!-- 售后原因 -->
          <el-table-column align="center" :label="$t('message.afterSalesReasons')" prop="confirm_at" width="100">
            <template slot-scope="scope">
              {{ setReasonName(scope.row.reason_type) }}
            </template>
          </el-table-column>
          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')" prop="type_name">
          </el-table-column>
          <!-- 提出人 -->
          <el-table-column align="center" :label="$t('message.peoplePutForward')" prop="created_admin.realname"
            width="100">
          </el-table-column>
          <!-- 确认人 -->
          <el-table-column align="center" :label="$t('message.affirmName')" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.confirm_admin">
                {{ scope.row.confirm_admin.realname }}
              </span>
            </template>
          </el-table-column>
          <!-- 售后时间 -->
          <el-table-column align="center" :label="$t('message.wafterSalesTime')" prop="confirm_at" width="100">
            <template slot-scope="scope">
              <p>审核时间：<br />{{ scope.row.complete_at }}</p>
              <p>完成时间：<br />{{ scope.row.confirm_at }}</p>
            </template>
          </el-table-column>
          <!-- 配送单号 -->
          <el-table-column align="center" :label="$t('message.deliveryNoteNumber')" width="180">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" class="a-link" target="_blank">
                  {{ scope.row.porder_sn }}</router-link>
              </p>
              <p>{{ scope.row.user.realname }}
                <attributeName :name="scope.row.user_attribute" />
              </p>
            </template>
          </el-table-column>
          <!-- 操作人员 -->
          <el-table-column align="center" :label="$t('message.operator')" width="130">
            <template slot-scope="scope">
              <div class="text-left">
                <!-- 业务员 -->
                <p>
                  {{ $t("message.salesman") }}：{{ scope.row.y_admin ? scope.row.y_admin.realname : '' }}
                </p>
                <!-- 配货员 -->
                <p>
                  {{ $t("message.distributionMember") }}：{{ scope.row.p_admin ? scope.row.p_admin.realname : '' }}
                </p>
                <!-- 采购员 -->
                <p>
                  {{ $t("message.buyer") }}：{{ scope.row.g_admin ? scope.row.g_admin.realname : '' }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 合计赔款.円 -->
          <el-table-column align="center" :label="$t('message.totalIndemnity')" prop="totalRefundToUserAmount">
          </el-table-column>
          <!-- 合计赔款.元 -->
          <!-- <el-table-column align="center" :label="$t('message.totalIndemnityYuan')" prop="totalRefundToUserAmount">
          </el-table-column> -->
          <!-- 关联赔款 -->
          <el-table-column align="center" :label="$t('message.associatedReparations')" width="215">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.reparations" :key="index">
                <router-link :to="'/wholeOrderAfterSale?after_sale_sn=' + scope.row.after_sale_sn" class="a-link"
                  target="_blank" v-if="scope.row.is_whole_porder == 1">
                  {{ item.reparation_sn }}
                </router-link>
                <router-link
                  :to="'/afterSaleOfGoods?after_sale_sn=' + scope.row.after_sale_sn + '&reparation_sn=' + item.reparation_sn"
                  class="a-link" target="_blank" v-else>
                  {{ item.reparation_sn }}
                </router-link>

                【{{ item.main_reparation_info }}】【{{ item.status_name }}】
              </p>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="status_name" width="80">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 名义设置-->
    <nominalSetting ref="nominalSetting" />
    <!-- 售后原因设置  -->
    <causeSetting ref="causeSetting" />
  </div>
</template>
<script>
import { indemnityStatus, afterSaleCategory } from "@/utlis/options";
import nominalSetting from "./components/nominalSetting";
import causeSetting from "./components/causeSetting";
export default {
  components: { nominalSetting, causeSetting },
  data() {
    return {
      tableautoheight: window.innerHeight > 500 ? window.innerHeight - 200 : 800,
      indemnityStatus,
      afterSaleCategory,
      reasonList: [],
      userList: [],
      datas: {
        status: "1",
        dateStart: "",
        dateEnd: "",
        porder_sn: "",
        user_id: "",
        after_sale_sn: "",
        reparation_sn: "",
        is_whole_porder: "",
        reparation_status_filter: "",
        reparation_amount_main: "",
        page: 1,
        pageSize: 10,
        org_id: "",
      },
      total: 0,
      tableData: [],
    };
  },
  created() {
    let status = this.$route.query.status
    if (status) {
      this.datas.status = status
    }
    if (this.$route.query.user_id) {
      this.datas.user_id = this.$route.query.user_id
    }
    if (this.$route.query.after_sale_sn) {
      this.datas.after_sale_sn = this.$route.query.after_sale_sn
    }
    this.aftersaleList();
    this.configReasonList()
  },
  methods: {
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.deadline_info) {

        return row.deadline_info.is_overtime ? 'warning-row' : ''

      }
      return '';
    },
    //售后原因列表
    configReasonList() {
      this.$api.capitalApi.configReasonList().then((res) => {
        this.reasonList = res.data;
      });
    },
    aftersaleList() {
      this.$api.capitalApi.aftersaleList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    setReasonName(type) {
      let name
      let data = this.reasonList.find(item => item.id == type)
      if (data) {
        name = data.name
      }
      return name
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.aftersaleList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.aftersaleList();
    },
    search() {
      this.datas.page = 1;
      this.aftersaleList();
    },
    reset() {
      this.datas = {
        status: "0",
        dateStart: "",
        dateEnd: "",
        porder_sn: "",
        user_id: "",
        after_sale_sn: "",
        reparation_sn: "",
        is_whole_porder: "",
        reparation_status_filter: "",
        reparation_amount_main: "",
        page: 1,
        pageSize: 10,
        org_id: "",
        hasReparation: '',
        reason_type: '',
      };
      this.$refs.cascader.orgId = [];
      this.aftersaleList();
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.reparation_amount_main = "";
    },
    // 名义设置
    chargeAdjustmentNominalSettingsThroughoutTheList() {
      this.$refs.nominalSetting.dialogVisible = true;
    },
    // 售后原因设置
    wholeListOfAftermarketReasonsSet() {
      this.$refs.causeSetting.dialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.tabs {
  position: relative;

  .operation {
    position: absolute;
    top: 0;
    right: 0
  }

  .annotation {
    position: absolute;
    top: 0;
    left: 380px;
    color: red;
    font-size: 18px;
    line-height: 38px;
  }
}

.search {
  margin: 20px 0;

  .row {
    display: flex;
    margin-bottom: 20px;
    position: relative;

    .item {
      margin-right: 24px;
      width: 200px;
    }
  }
}

/deep/.warning-row {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

/deep/.el-table tbody .warning-row:hover>td {
  background-color: rgba(242, 210, 235, 0.5) !important;
}
</style>